/**
 * @generated SignedSource<<608463ab6c21736ef6655226f7b8007b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ABTestDeliverDayOfWeeks_abtestScenarioPageGroup$data = {
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly deliverDayOfWeeks: ReadonlyArray<{
    readonly weekOfMonth: number | null;
    readonly daysOfWeek: ReadonlyArray<DayOfWeek>;
  }>;
  readonly schedules: ReadonlyArray<{
    readonly id: string;
    readonly startTime: string | null;
    readonly endTime: string | null;
  }>;
  readonly " $fragmentType": "ABTestDeliverDayOfWeeks_abtestScenarioPageGroup";
};
export type ABTestDeliverDayOfWeeks_abtestScenarioPageGroup = ABTestDeliverDayOfWeeks_abtestScenarioPageGroup$data;
export type ABTestDeliverDayOfWeeks_abtestScenarioPageGroup$key = {
  readonly " $data"?: ABTestDeliverDayOfWeeks_abtestScenarioPageGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ABTestDeliverDayOfWeeks_abtestScenarioPageGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ABTestDeliverDayOfWeeks_abtestScenarioPageGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DeliverDayOfWeek",
      "kind": "LinkedField",
      "name": "deliverDayOfWeeks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekOfMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "daysOfWeek",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AbtestScenarioPageGroup",
  "abstractKey": null
};

(node as any).hash = "b6f0328b03d51ec65b990c0ead9495d8";

export default node;
